import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import {
	type ComponentPropsWithoutRef,
	type ElementRef,
	forwardRef,
} from 'react'
import { Icon } from '#app/ui/components'
import { cn } from '#app/utils/tailwind-merge.ts'

export type CheckboxProps = Omit<
	ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>,
	`type`
> & {
	type?: string
}

export const Checkbox = forwardRef<
	ElementRef<typeof CheckboxPrimitive.Root>,
	ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
	<CheckboxPrimitive.Root
		ref={ref}
		className={cn(
			`peer h-4 w-4 shrink-0 rounded-sm border border-brand-muted-amethyst disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-muted-900 data-[state=checked]:text-muted-50`,
			className,
		)}
		{...props}
	>
		<CheckboxPrimitive.Indicator
			className={cn(`flex items-center justify-center text-current`)}
		>
			<Icon name="check" className="h-4 w-4" />
		</CheckboxPrimitive.Indicator>
	</CheckboxPrimitive.Root>
))
Checkbox.displayName = CheckboxPrimitive.Root.displayName
